import { useState, useEffect } from 'react';
import { useParams, Link, useNavigate } from 'react-router-dom';
import { getAnnouncementById } from '../utils/supabase';
import ReactMarkdown from 'react-markdown';

const AnnouncementDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [announcement, setAnnouncement] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    loadAnnouncement();
  }, [id]);

  const loadAnnouncement = async () => {
    setLoading(true);
    const { data, error } = await getAnnouncementById(id);
    if (error || !data) {
      setError('Announcement not found');
      setLoading(false);
      return;
    }
    setAnnouncement(data);
    setLoading(false);
  };

  if (loading) {
    return (
      <div className="min-h-[calc(100vh-64px)] flex items-center justify-center">
        <div className="spinner"></div>
      </div>
    );
  }

  if (error || !announcement) {
    return (
      <div className="min-h-[calc(100vh-64px)] flex items-center justify-center">
        <div className="text-center">
          <div className="text-4xl mb-4">😕</div>
          <p className="text-gray-500">{error || 'Announcement not found'}</p>
          <Link
            to="/announcements"
            className="inline-block mt-4 px-4 py-2 bg-primary text-white rounded-lg hover:bg-primary/90 transition"
          >
            Back to Announcements
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-[calc(100vh-64px)] pb-24">
      <div className="container-custom py-6">
        <Link
          to="/announcements"
          className="inline-flex items-center gap-2 text-primary hover:underline mb-6"
        >
          ← Back to Announcements
        </Link>

        <div className="bg-white rounded-xl p-6 md:p-8 shadow-sm">
          <div className="mb-6">
            <h1 className="text-3xl md:text-4xl font-bold mb-4">{announcement.title}</h1>
            <div className="flex flex-wrap items-center gap-3 text-sm text-gray-500">
              <span>
                By {announcement.profiles?.full_name || 'Unknown'}
              </span>
              <span>•</span>
              <span>
                {new Date(announcement.created_at).toLocaleDateString('en-US', {
                  weekday: 'long',
                  month: 'long',
                  day: 'numeric',
                  year: 'numeric',
                })}
              </span>
              <span>•</span>
              <span>
                {new Date(announcement.created_at).toLocaleTimeString('en-US', {
                  hour: '2-digit',
                  minute: '2-digit',
                })}
              </span>
            </div>
          </div>

          <div className="prose prose-lg max-w-none">
            <ReactMarkdown>
              {announcement.content}
            </ReactMarkdown>
          </div>

          <div className="mt-8 pt-6 border-t border-gray-200">
            <Link
              to="/announcements"
              className="text-primary hover:underline"
            >
              ← View all announcements
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AnnouncementDetail;
